import { Dispatch } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import {
  ICreateFiltersProductListActions,
  ICreateFiltersProductOverviewActions,
  ICreateFiltersManhattanActions,
  ISetSearchParamsProductListActions,
  ISetSearchParamsProductOverviewActions,
  ISetSearchParamsManhattanActions,
} from "./types";

export function createSearchParamsProductListAction(params: any): ICreateFiltersProductListActions {
  return {
    type: ActionTypes.SEARCH_PARAMS.PRODUCT_LIST.CREATE,
    payload: params,
  };
}

export function searchProductListAction(searchKeyword: string): ICreateFiltersProductListActions {
  return {
    type: ActionTypes.SEARCH_PARAMS.PRODUCT_LIST.SEARCH,
    payload: searchKeyword,
  };
}

export function createSearchParamsProductOverviewAction(params: any): ICreateFiltersProductOverviewActions {
  return {
    type: ActionTypes.SEARCH_PARAMS.PRODUCT_OVERVIEW.CREATE,
    payload: params,
  };
}

export function createSearchParamsManhattanAction(params: any): ICreateFiltersManhattanActions {
  return {
    type: ActionTypes.SEARCH_PARAMS.MANHATTAN.CREATE,
    payload: params,
  };
}

export function setSearchParamsProductListAction(params: any): ISetSearchParamsProductListActions {
  return {
    type: ActionTypes.SEARCH_PARAMS.PRODUCT_LIST.SET,
    payload: {
      items: params,
    },
  };
}

export function setSearchParamsProductOverviewAction(params: any): ISetSearchParamsProductOverviewActions {
  return {
    type: ActionTypes.SEARCH_PARAMS.PRODUCT_OVERVIEW.SET,
    payload: {
      items: params,
    },
  };
}

export function setSearchParamsManhattanAction(params: any): ISetSearchParamsManhattanActions {
  return {
    type: ActionTypes.SEARCH_PARAMS.MANHATTAN.SET,
    payload: {
      items: params,
    },
  };
}

export const clearSearchParamsProductListAction = () => (dispatch: Dispatch) => {
  return dispatch({
    type: ActionTypes.SEARCH_PARAMS.PRODUCT_LIST.CLEAR,
  });
};

export const clearSearchParamsProductOverviewAction = () => (dispatch: Dispatch) => {
  return dispatch({
    type: ActionTypes.SEARCH_PARAMS.PRODUCT_OVERVIEW.CLEAR,
  });
};

export const clearSearchParamsManhattanAction = () => (dispatch: Dispatch) => {
  return dispatch({
    type: ActionTypes.SEARCH_PARAMS.MANHATTAN.CLEAR,
  });
};
